import React, {Fragment} from "react";
import {PageHeader} from "./PageHeader";
import {useContent} from "../customHooks/useContent";
import content from "../content/projects";
import {generateRandomKey} from "../utils/generateRandomKey";
import {Project} from "./Project";

export const Projects = () => {
    const text = useContent(content);

    const renderProjects = () => {
        return text.projects.map((project) => {
            return (
                <div className="row" key={generateRandomKey()}>
                    <Project project={project} />
                </div>
            )
        })
    };

    return (
        <Fragment>
            <PageHeader subtitle={text.subtitle} imageClass={'header-projects'}/>
            <main className="projects">
                <div className="container">
                    {text.projects?.length > 0 ? renderProjects() : ''}
                </div>
            </main>
        </Fragment>
    );
};
